import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalConfig, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ServiceForm } from '../../../../../../app/core/Interfaces/ui-interface';
import { PermissionService } from '../../../../../../app/core/services/permission.service';
import { AppSweetAlert } from '../../../../../../app/core/utils/app-sweet-alert';
import { LocalStorageService } from '../../../../../../app/core/utils/local-stoarge-service';
import { GlobalName } from '../../../../../../app/core/utils/global-name';
import { AppActionCheck } from '../../../../../../app/core/utils/app-action-check';
import { Windows } from '../../../../../../app/core/utils/windows';
import { Permissions } from '../../../../../../app/core/utils/permissions';
import { AppErrorShow } from '../../../../../../app/core/utils/app-error-show';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgxPaginationModule } from 'ngx-pagination';
import { SampleSearchPipe } from '../../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../../shared/loading/loading.component';
import { NgSelectModule } from '@ng-select/ng-select';
@Component({
  selector: 'app-permission',
  templateUrl: './permission.component.html',
  styleUrls: ['./permission.component.css'],
  standalone:true,
  imports:[
     CommonModule,
        FormsModule,
        NgbModule,
        NgxPaginationModule,
        LoadingComponent,
        SampleSearchPipe,
        NgSelectModule
  ]
})
export class PermissionComponent implements OnInit {
  buttonsPermission :any|undefined;
  structures:any[] =[]
  actions:any[] =[]
  data:any[] =[]
  features:any[] =[]
  permissions:any
  selectedWindow:any
  selected_data:any;
  modalOption:any; 
  isDtInitialized:boolean = false
  is_active=null
  loading=false
  tag="Permissions"
  permissionName=""
    search_text=""
  role:any
  user:any
  feature:any
  action:any
  loading2=false
pg={
    pageSize:10,
    p:0,
    total:0
  }


  constructor(
    private permissionService:PermissionService,
    private toastrService:ToastrService,
      config: NgbModalConfig,
      private lsService:LocalStorageService,
    private modalService: NgbModal) {
     config.backdrop = 'static';
     config.keyboard = false;
     }


  ngOnInit(): void {
    this.init()

    let check=this.lsService.get(GlobalName.features)
    this.features=check?.features
    this.actions=check?.actions
    this.getActions()
  }

  init(){
    this.getAll()
  
  }

 

  getAll(){
    this.loading2=true

    this.permissionService.getAll().subscribe((res:any)=>{
      this.data=res.data 
this.pg.pageSize=10
 this.pg.p=0
 this.pg.total=res.data.length
      this.modalService.dismissAll()
      this.loading2=false

    },
    (err:any)=>{
      this.loading2=false
      AppErrorShow.showError("Gestion des permissions",err)

    })
  }


  store(value:any){
    this.loading=true
    let data:any[]=[]

    value.feature.forEach((f:any)=>{
      value.action.forEach((a:any)=>{
        data.push({
          name:`${a} ${f}` ,
          guard_name:'api'
        })
      })
    })
    this.permissionService.store(data).subscribe((res:any)=>{
      this.loading=false
      this.toastrService.success(res.message)
      this.getAll()

    },
    (err:any)=>{
      this.loading=false

      console.log(err)
      AppErrorShow.showError("Gestion des permissions",err)
    })
  }
  update(value:any){
    this.loading=true

    this.permissionService.update(this.selected_data.id,{name:`${value.action} ${value.feature}` }).subscribe((res:any)=>{
      this.loading=false

        this.toastrService.success(res.message)
        this.getAll()
    },
    (err:any)=>{
      this.loading=false

      console.log(err)
      AppErrorShow.showError("Gestion des permissions",err)
    })
  }
  delete(){
    if(!this.verifyIfElementChecked()) return ;
    let confirmed=AppSweetAlert.confirmBox('info','Suppression','Voulez vous vraiment retirer cet élément?',);
    confirmed.then((result:any)=>{
       if (result.isConfirmed) {
    this.permissionService.delete(this.selected_data.id).subscribe((res:any)=>{
        this.toastrService.success(res.message)
        this.getAll()
    },
    (err:any)=>{
      console.log(err)
      AppErrorShow.showError("Gestion des permissions",err)
    })
  }
})
  }
  checked(el?:any){
    this.selected_data=el;
    this.is_active=el.is_active
    let expFeature=this.selected_data.name.split(' ');
    this.action=expFeature[0]
    this.feature=expFeature.slice(1).join(' ')
  }
  verifyIfElementChecked(){
    console.log(this.selected_data)
    if (this.selected_data==null) {
      this.toastrService.warning("Aucun élément selectionné");
      return false;
    }
    return true;
  }



  dismiss(){
    this.modalService.dismissAll()
  }

  add(content:any){
    this.modalService.open(content,{size:'lg'});
  }


  show(content:any){
    if(!this.verifyIfElementChecked()) return ;
    this.modalOption={centered:false,size:"lg"}
    this.modalService.open(content,{size:'lg'});
  }

  edit(content:any){
    if(!this.verifyIfElementChecked()) return ;
    this.modalService.open(content,{size:'lg'});

  }


getActions(){
    this.buttonsPermission = {
      show:AppActionCheck.check(this.tag,'Consulter'),
      add:AppActionCheck.check(this.tag,'Ajouter'),
      edit:AppActionCheck.check(this.tag,'Editer'),
      delete:AppActionCheck.check(this.tag,'Supprimer'),
      status:AppActionCheck.check(this.tag,'Mettre un statut'),
      print:AppActionCheck.check(this.tag,'Imprimer/Télécharger'),
      transUp:AppActionCheck.check(this.tag,'Transmettre'),
      transDown:AppActionCheck.check(this.tag,'Affecter'),
      sign:AppActionCheck.check(this.tag,'Signer'),
      viewer:AppActionCheck.check(this.tag,'Visualiser Fichier'),
      return:AppActionCheck.check(this.tag,'Retouner pour correction')
    };
   
  }

 

  setValue(i:any){
    this.permissions[i].value= !this.permissions[i].value
  }

  getJson(actions:any){
    return JSON.parse(actions)
  }

  getPage(event:any){
    this.pg.p=event
  }
}
